import { Rules, Norms } from 'sigma-mappings';

const chromatographyNormsDictionary = vm => ([
  {
    id: Rules.IEC_60599,
    name: vm.$t('enums.engineering.chromatography.rules.iec-60599'),
  },
  {
    id: Rules.IEEE_C57_104,
    name: vm.$t('enums.engineering.chromatography.rules.ieee-c57-104'),
  },
  {
    id: Rules.NBR_7274,
    name: vm.$t('enums.engineering.chromatography.rules.nbr-7274'),
  },
  {
    id: Rules.DUVAL,
    name: vm.$t('enums.engineering.chromatography.rules.duval'),
  },
]);

const physicalChemicalNormsDictionary = vm => ([
  {
    id: Norms.IEC_60422_2013,
    name: vm.$t('enums.engineering.physical-chemical.norms.iec-60422-2013'),
  },
  {
    id: Norms.IEEE_C57_106_2015,
    name: vm.$t('enums.engineering.physical-chemical.norms.ieee-c57-106-2015'),
  },
  {
    id: Norms.NBR_10576_2012,
    name: vm.$t('enums.engineering.physical-chemical.norms.nbr-10576-2012'),
  },
  {
    id: Norms.NBR_10576_2017,
    name: vm.$t('enums.engineering.physical-chemical.norms.nbr-10576-2017'),
  },
]);

export {
  chromatographyNormsDictionary,
  physicalChemicalNormsDictionary,
};
